export default {
  'admin.Home': '主页',
  'admin.Dashboard': '仪表盘',
  'admin.You are logged in as a administrator.': '您当前的角色为系统管理员',
  'admin.ROAR Window': 'ROAR窗口',
  'admin.Database': '数据库',
  'admin.Permission': '账号管理',
  'admin.Create New Period': '创建一个新的ROAR窗口',
  'admin.New Period': '新的ROAR窗口',
  'admin.Edit Period': '编辑ROAR窗口',
  'admin.Period Name': 'ROAR窗口名称',
  'admin.Please Input': '请输入',
  'admin.Period Type': '窗口类型',
  'admin.Online': '线上',
  'admin.Offline': '线下',
  'admin.Employee Application Period': '潜力狮申请阶段',
  'admin.The entire timeline for Project ROAR, from project start day to the day it ends (several days after Panel Result Submission end day).': '出狮行动的整体时间，从项目开始日到结束日（出狮结果上传结束日之后的几天）',
  'admin.Edit': '编辑',
  'admin.Publish Manager': '对狮厂经理发布结果',
  'admin.Publish Employee': '对潜力狮发布结果',
  'admin.Delete': '删除',
  'admin.Review Manager Assessment Period': '狮厂经理评估阶段',
  'admin.HRBP Assessment Period': 'HRBP审查阶段',
  'admin.Panel Result Upload Period': '出狮结果上传阶段',
  'admin.Action': '操作',
  'admin.Publish Result': '发布结果',
  'admin.HRBP Review Period': 'HRBP审查阶段',
  'admin.Panel Result Submission Period': '出狮结果上传阶段',
  'admin.From one day after HRBP Review end day to the last day that requires HRBP to upload panel result after getting global confirmation.': '允许HRBP上传经集团总部确认结果后的出狮结果的时段（开始日期为HRBP评估结束的后一天）',
  'admin.From the start day to the last day that requires the employee to submit application.': '允许潜力狮提交出狮申请的时段',
  'admin.From the start day to the last day that requires the manager to submit assessment (several days after “Employee Application” end day).': '允许狮厂经理提交审批结果的时段（结束日期应在潜力狮申请结束日期的后几天）',
  'admin.From the start day to the last day that allows HRBP to reopen assessment (several days after “Manager Assessment” end day). Application approval status will be published after HRBP Review end day.': '允许HRBP重启评估的时段（结束日期应在狮厂经理审批结束日期的后台几天）经理评估结果将在HRBP评估结束日期的后一天自动发布。',
  'admin.Select date': '选择日期',
  'admin.Cancel': '取消',
  'admin.Save': '保存',
  'admin.Are you sure you want to publish result?': '您确定想要发布此次结果吗？',
  'admin.Yes': '是',
  'admin.No': '否',
  'admin.Deleted successfully': '删除成功',
  'admin.Published successfully': '发布成功',
  'admin.Employee': '潜力狮',
  'admin.Upload Employee List': '上传潜力狮名单',
  'admin.Download Employee List': '下载潜力狮名单',
  'admin.View History': '查看历史',
  'admin.Employee / Review Manager': '潜力狮/狮厂经理',
  'admin.Employee / Review Manager / Brand': '潜力狮/狮厂经理/品牌',
  'admin.Employees': '潜力狮',
  'admin.Total': '总计',
  'admin.Transfer': '修改关联信息',
  'admin.Career Guide': '发展指南',
  'admin.Review Manager Permission': '狮厂经理账号',
  'admin.Review Manager': '狮厂经理',
  'admin.Review Managers': '狮厂经理',
  'admin.HRBP': 'HRBP',
  "admin.Please make sure there is at least one ROAR window and it's before apply start time": '请确保至少有一个ROAR窗口，且窗口开启日期在申请日期之前',
  'admin.Reopen Both': '同时重启潜力狮申请及狮厂经理评估',
  'admin.Reopen Review Manager': '仅重启狮厂经理评估',
  'admin.View Comments': '查看评语',
  'admin.Time of Action': '操作时间',
  'admin.Close': '关闭',
  'admin.User': '用户',
  'admin.File Name': '文件名',
  'admin.Lion ID': 'Lion ID',
  'admin.Name': '姓名',
  'admin.Current Role': '当前角色职级',
  'admin.Target Role': '目标角色职级',
  'admin.Current Brand': '当前所属品牌',
  'admin.Target Brand': '目标所属品牌',
  'admin.Location': '地点',
  'admin.Status': '状态',
  'admin.Assessment Result': '评估结果',
  'admin.Back': '返回',
  'admin.Learning': '学习课程',
  'admin.Mandatory': '必修课程',
  'admin.No Comments': '无评语',
  'admin.Learning Link': '课程链接',
  'admin.Learning Record': '学习记录',
  'admin.Upload Career Guide': '上传发展指南',
  'admin.Upload Guide': '上传发展指南',
  'admin.File Name / Creator': '文件名/上传者',
  'admin.Files': '文件',
  'admin.File': '文件',
  'admin.Creator': '上传者',
  'admin.Upload Time': '上传时间',
  'admin.Download': '下载',
  'admin.Rename': '重命名',
  'admin.Download EN Template': '下载英文模板',
  'admin.Upload Learning Link': '上传课程链接',
  'admin.Upload Learning Record': '上传学习记录',
  'admin.Rename File': '重命名文件',
  'admin.Please download the template for uploading': '请下载需要填写并上传的模板',
  'admin.Upload': '上传',
  'admin.Upload EN File': '上传英文版文件',
  'admin.Select the file (System will renew the items in the list from the uploaded document)': '选择文件（系统将自动将上传的文件更新至列表中）',
  'admin.Add New Employee': '添加新潜力狮',
  'admin.Download Employee Application Records': '下载潜力狮申请记录',
  'admin.Employee Permission': '潜力狮账号',
  'admin.Edit Employee': '编辑潜力狮信息',
  'admin.Employee LLID': '潜力狮LLID',
  'admin.Employee CS ID': '潜力狮CS ID',
  'admin.Employee English Name': '潜力狮姓名',
  'admin.Employee Email Address': '潜力狮邮箱',
  'admin.Employee Title': '潜力狮职位',
  'admin.Level1': 'Level1',
  'admin.SubLevel': 'SubLevel',
  'admin.Level2': 'Level2',
  'admin.Level3': 'Level3',
  'admin.Job Grading': 'Job Grading',
  'admin.Please Select': '请选择',
  'admin.Add': '添加',
  'admin.Location of Employee': '工作地点',
  'admin.HFM Code': 'HFM Code',
  'admin.Department/Client': 'Department/Client',
  'admin.Parent Function': 'Parent Function',
  'admin.Child Function': 'Child Function',
  'admin.Join Date': '入职日期',
  'admin.Review Manager Name(EN)': '狮厂经理姓名',
  'admin.LLID of Review Manager': '狮厂经理LLID',
  'admin.LLID of HRBP': 'LLID of HRBP',
  'admin.Review Manager Email Address': '狮厂经理邮箱',
  'admin.Review Manager Title': '狮厂经理职位',
  'admin.Brand of Review Manager': '狮厂经理所属品牌',
  'admin.HRBP Name (EN)': 'HRBP姓名',
  'admin.HRBP Email Address': 'HRBP邮箱',
  'admin.Download employee application record': '下载潜力狮申请记录',
  'admin.Download Current Record': '下载本轮申请记录',
  'admin.Download all Record': '下载历史全部申请记录（含本轮）',
  'admin.Title': '职位',
  'admin.The application is waiting for review manager to review.': '该申请正在等待狮厂经理审批',
  'admin.The panel review application has been approved.': '狮厂经理已审批，同意进入管理层评估环节',
  'admin.The panel review application is not approved.': '狮厂经理已审批，未同意进入管理层评估环节',
  "admin.The talent's application is reopened.": '潜力狮的申请被重启',
  'admin.Role Change': '修改角色关联信息',
  'admin.Change': '修改',
  'admin.Dual Role': '双重身份',
  'admin.Cancel Account': '注销账号',
  'admin.Are you sure you want to cancel the current account?': '您确定要注销当前账户吗？',
  'admin.Add New Review Manager': '添加新狮厂经理',
  'admin.HRBPs': 'HRBPs',
  'admin.HRBP Permission': 'HRBP账号',
  'admin.Add New HRBP': '添加新HRBP',
  'admin.Edit HRBP': '编辑HRBP',
  'admin.If you leave before saving, your changes will be lost': '如果您在离开前不保存，则所有修改将无效',
  'admin.OK': '确认',
  'admin.Ok': '确认',
  'admin.Reset': '重置',
  'admin.All': '全选',
  'admin.Reopen': '重启',
  'admin.Are you sure you want to reopen review manager’s assessment and employee’s application?': '您确定需要重启潜力狮的申请及狮厂经理的评估吗？',
  'admin.Are you sure you want to reopen review manager’s assessment?': '您确定需要重启狮厂经理的评估吗？',
  'admin.Delete File': '删除文件',
  'admin.Are you sure you want to delete the file?': '确定删除此文件？',
  'admin.Found the duplicated data. Do you want to replace?': '发现重复数据。需要覆盖吗？',
  'admin.Clear All': '清除全部',
  'admin.Apply': '应用',
  'admin.Download Template': '下载模板',
  'admin.Upload File': '上传文件',
  'admin.Select ROAR Window': '选择ROAR窗口',
  'admin.You have successfully uploaded the Employee List.': '您已成功上传潜力狮名单',
  'admin.You did not upload the Employee List successfully': '上传潜力狮名单失败',
  'admin.Incorrect Excel template type': 'Excel模板类型错误',
  'admin.Review Manager can now re-assess.': '狮厂经理现在可以重新评估',
  'admin.Review manager and employee can now re-assess.': '潜力狮现在可以重新申请，提交后狮厂经理可以重新评估',
  'admin.Selected': '已选择',
  'admin.items': '项',
  'admin.Panel Result': '出狮结果',
  'admin.Panel Comments': '管理层评语',
  'admin.Role': '角色',
  'admin.Please enter the correct LionID': '请输入正确的LionID',
  'admin.Update Result': '编辑结果',
  'admin.Update Employee Result': '编辑结果',
  'admin.Please select the panel result': '请选择出狮结果',
  'admin.You have successfully updated the employee result': '您已成功修改员工出狮结果',
  'admin.Failed to update employee result': '修改员工出狮结果失败',
  'admin.Review Manager Comments': '狮厂经理评语',
  'admin.Employee Comments': '潜力狮评语',
  'admin.Result Comments': '评语',
  'admin.No comments': '暂无评语',
  'admin.Batch Upload Result': '批量上传结果',
  'admin.Upload Result Excel': '上传结果Excel',
  'admin.Download Result Template': '下载结果模板',
  'admin.Upload Result File': '上传结果文件',
  'admin.Select the result file (Excel)': '选择结果文件（Excel）',
  'admin.Preview Data': '预览数据',
  'admin.Result Value': '结果值',
  'admin.Total Records': '总记录数',
  'admin.Confirm Upload': '确认上传',
  'admin.Invalid file format': '文件格式不正确',
  'admin.Please upload Excel file': '请上传Excel文件',
  'admin.Batch update successful': '批量更新成功',
  'admin.Batch update failed': '批量更新失败',
  'admin.No valid data in file': '文件中没有有效数据',
  'admin.You have successfully transferred the selected employees to the new manager/HRBP': '您已经成功地将选定的员工移交给新的经理/HRBP',
  'admin.You have successfully added a new hrbp': '您已成功添加新hrbp',
  'admin.You have successfully updated hrbp information': '您已成功更新hrbp信息',
  'admin.Renamed successfully.': '重命名成功',
  'admin.Updated successfully': '更新成功',
  'admin.You have successfully updated review manager information.': '您已成功更新狮厂经理信息',
  'admin.You have successfully added a new review manager.': '您已成功添加新狮厂经理',
  'admin.Edit Review Manager': '编辑狮厂经理',
  'admin.Incorrect mailbox format': '邮箱格式错误',
  'admin.Click to sort descending': '点击降序',
  'admin.Click to sort ascending': '点击升序',
  'admin.Click to cancel sorting': '取消排序',
  'admin.Are you sure to add employee identity rights for this manager?': '是否确定为该经理添加员工权限？',
  'admin.Are you sure to add manager identity rights for this employee?': '是否确定为该员工添加经理权限？',
  'admin.Dual': '确认',
  'admin.You have successfully added manager privileges for this employee': '您已成功为该员工添加经理权限',
  'admin.You have successfully added employee privileges for this manager': '您已成功为该经理添加员工权限',
  'admin.Period type cannot be changed when status is active': '状态激活后窗口类型不可修改',
}
